<template>
  <div v-if="params.data.__typename !== 'Folder'" class="ag-cell-icon-count-renderer">
    <component :is="icon" />{{ params.value }}
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, defineAsyncComponent } from 'vue';
import { ICellRendererParams } from 'ag-grid-enterprise';

export default defineComponent({
  name: 'IconCountRenderer',

  props: {
    params: { type: Object as PropType<ICellRendererParams<any, any> & { icon: string }>, required: true },
  },

  computed: {
    icon(): ReturnType<typeof defineAsyncComponent> {
      if (this.params.icon) {
        return defineAsyncComponent(() => import(`@components/Icons/${this.params.icon}.vue`));
      }

      return defineAsyncComponent(() => import('@components/Icons/CodeIcon16.vue'));
    },
  },
});
</script>

<style lang="scss">
@use 'settings/settings';
.ag-cell-icon-count-renderer {
  display: grid;
  align-items: center;
  grid-template-columns: auto 1fr;
  grid-gap: 8px;
  height: settings.$grid-list-inner-row-height * 1px;
}
</style>
